import React, { PropsWithChildren } from 'react'

import { useWindowResize } from '@utils/domUtils'

import type { CommonModalTitleProps, ModalProps } from '../types'
import { DataListModalDesktop } from './DataListModalDesktop'
import { DataListModalMobile } from './DataListModalMobile'

interface DataListModalProps extends PropsWithChildren<CommonModalTitleProps & ModalProps> {
  isLoading?: boolean
  renderFooter?(props: DataListModalProps): React.ReactNode[]
  onClose(): void
}

export const DataListModal: React.FC<DataListModalProps> = (props) => {
  const isMobile = useWindowResize()
  return isMobile ? <DataListModalMobile {...props} /> : <DataListModalDesktop {...props} />
}
